import { generateChildrenFromList } from "cms/parsers";
import { H2 } from 'dma-ui-kit';

const SponsorGroup = props => {
    const { relationships, attributes } = props.paragraph;

    const title = attributes.field_title;
    const sponsors = generateChildrenFromList(relationships.field_sponsors.data);
    
    return (
        <>
            <H2>{title}</H2>
            {sponsors}
        </>
    );
};

export default SponsorGroup;
